<template>
  <div class="template-container">
    <!-- Survey cards -->
    <div v-for="(survey, index) in surveys" :key="survey.sID" class="card">
      <div class="card-body">
        <h4 class="card-title">{{ survey.name }}</h4>
        <p class="card-date">Due: {{ formatDate(survey.endTime) }}</p>
        <p class="card-desc">{{ survey.description || 'This project does not have any description.' }}</p>
        <div class="tag-list">
          <span v-for="tag in survey.tags" :key="tag" class="tag-chip">{{ tag }}</span>
        </div>
      </div>

      <div class="card-actions center">
        <button class="btn view" @click="openViewModal(index)">View Details</button>
        <button class="btn delete" @click="openDeleteModal(index)">Delete</button>
      </div>

      <b-modal :id="'view-template' + index" title="View Template" size="xl" hide-footer @shown="onModalShown" @hidden="onModalHidden">
        <div class="modal-title">{{ survey.name }}</div>
        <ViewTemplate :template="survey" :index="index" />
      </b-modal>

      <b-modal :id="'delete-confirm' + index" centered title="Confirm" @shown="onModalShown" @hidden="onModalHidden">
        <p class="confirm-text">Are you sure you want to delete?</p>
        <template #modal-footer>
          <b-button class="btn cancel" @click="closeDeleteModal(index)">Cancel</b-button>
          <b-button class="btn delete" @click="deleteSurvey(survey.sID, index)">Delete</b-button>
        </template>
      </b-modal>
    </div>

    <!-- Game cards -->
    <div
      v-if="userType === 0"
      v-for="(game, index) in currentGames"
      :key="game.gameID"
      class="card"
    >
      <div class="card-image">
        <img :src="game.img" alt="Game Image" />
      </div>

      <div class="card-body">
        <h4 class="card-title">{{ game.name }}</h4>
        <p class="card-date">Due: {{ formatDate(game.endTime) }}</p>
        <p class="card-desc">{{ game.description || 'This project does not have any description.' }}</p>
        <div class="tag-list">
          <span v-for="tag in game.tags" :key="tag" class="tag-chip">{{ tag }}</span>
        </div>
      </div>

      <div class="card-actions center">
        <button class="btn view" @click="showDetailsPopup(game.name, game.description, game.img)">View Details</button>
        <button class="btn join" @click="testerRegistered(game.gameID)">Join</button>
      </div>
    </div>

    <!-- Details Popup Modal -->
    <div v-if="detailsPopupVisible" class="popup-overlay" @click="closeDetailsPopup">
      <div class="popup-content" @click.stop>
        <button class="btn-close-circle--dark" @click="closeDetailsPopup">×</button>
        <div class="popup-body">
          <img v-if="selectedProject.img && selectedProject.img !== ''" 
               class="popup-img" 
               :src="selectedProject.img" 
               alt="Project Image" />
          <div class="popup-text">
            <h3 class="popup-title">{{ selectedProject.name }}</h3>
            <p class="popup-description">{{ selectedProject.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ViewTemplate from '../../survey-create/search-templates-components/ViewTemplate.vue'
import PlayTesterUser from '../../../Firestore/PlayTesterUser.js'

export default {
  name: 'GridViewTemplate',
  components: { ViewTemplate },
  props: ['surveys', 'games'],
  data() {
    return {
      userId: window.localStorage.getItem('userId'),
      userType: window.localStorage.getItem('userType')
        ? parseInt(window.localStorage.getItem('userType'))
        : -1,
      currentGames: this.games,
      tagsOverflowing: [],
      detailsPopupVisible: false,
      selectedProject: {
        name: '',
        description: '',
        img: ''
      }
    }
  },
  watch: {
    games(newGames) {
      this.currentGames = newGames
    },
    detailsPopupVisible(newVal) {
      this.$emit('modal-state-changed', newVal);
    }
  },
  mounted() {
    window.addEventListener('resize', this.resizeHandler)
    this.tagsOverflowing = Array(this.surveys.length).fill(false)
    this.resizeHandler()
  },
  unmounted() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    showDetailsPopup(gameName, gameDescription, gameImg) {
      console.log('Project details:', { gameName, gameDescription, gameImg });
      this.selectedProject.name = gameName;
      this.selectedProject.description = gameDescription || 'No description available.';
      this.selectedProject.img = gameImg;
      this.detailsPopupVisible = true;
    },
    
    closeDetailsPopup() {
      this.detailsPopupVisible = false;
    },
    
    openViewModal(index) {
      this.$bvModal.show('view-template' + index);
    },
    
    openDeleteModal(index) {
      this.$bvModal.show('delete-confirm' + index);
    },
    
    onModalShown() {
      this.$emit('modal-state-changed', true);
    },
    
    onModalHidden() {
      this.$emit('modal-state-changed', false);
    },
    
    modalId(index) {
      return 'view-template' + index
    },
    
    deleteModalId(index) {
      return 'delete-confirm' + index
    },
    
    closeConfirmModal(index) {
      this.$bvModal.hide('view-template' + index)
    },
    
    closeDeleteModal(index) {
      this.$bvModal.hide('delete-confirm' + index)
    },
    
    deleteSurvey(surveyId, index) {
      const survey = this.surveys.find((survey) => survey.sID === surveyId)
      this.$emit('delete-survey', survey)
      this.closeDeleteModal(index)
    },
    
    resizeHandler() {
      this.surveys.forEach((value, i) => {
        const element = document.getElementById('tag-container-' + value.sID)
        if (this.checkOverflow(element)) {
          Vue.set(this.tagsOverflowing, i, true)
        } else {
          Vue.set(this.tagsOverflowing, i, false)
        }
      })
    },
    
    checkOverflow(el) {
      if (!el) return false
      const curOverflow = el.style.overflow
      if (!curOverflow || curOverflow === 'visible') el.style.overflow = 'clip'
      const isOverflowing =
        el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight
      el.style.overflow = curOverflow
      return isOverflowing
    },
    
    testerRegistered(gameId) {
      PlayTesterUser.createTester(gameId, this.userId)
        .then(() => {
          this.currentGames = this.currentGames.filter(
            (game) => game.gameID !== gameId
          )
          console.log('Tester registered')
        })
        .catch((error) => {
          console.log(error)
        })
    },
    
    formatDate(dateStr) {
      if (!dateStr) return '--'
      const date = new Date(dateStr)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    }
  }
}
</script>

<style scoped>
.template-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: flex-start;
  padding: 1.5rem 1rem;
  background: #fafafa;
  position: relative;
}

.card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  width: calc(31% - 1rem);
  min-width: 260px;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  position: relative;
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(255, 114, 34, 0.2);
}

.card-image {
  width: 100%;
  height: 200px;
  background-color: #f4f4f4;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.card-body {
  padding: 1rem 1.2rem;
  flex-grow: 1;
}

.card-title {
  color: #ff7222;
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
}

.card-date {
  color: #888;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
}

.card-desc {
  color: #555;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-bottom: 0.8rem;
  min-height: 2.4em;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tag-chip {
  background: #fff3ea;
  color: #ff7222;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 10px;
}

.card-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  padding: 0.9rem 1rem;
  border-top: 1px solid #f1f1f1;
  background: #fff;
}

.btn {
  border: none;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}

.btn.view {
  background: #f7f7f7;
  color: #333;
}
.btn.view:hover {
  background: #e9e9e9;
}

.btn.join {
  background: linear-gradient(135deg, #ff7222, #ff8e4d);
  color: white;
  box-shadow: 0 3px 6px rgba(255, 114, 34, 0.3);
}
.btn.join:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(255, 114, 34, 0.4);
}

.btn.delete {
  background: linear-gradient(135deg, #d9534f, #e56b68);
  color: white;
}
.btn.delete:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(213, 73, 71, 0.4);
}

.btn.cancel {
  background: #f0f0f0;
  color: #333;
}

.confirm-text {
  color: #333;
  font-size: 1rem;
  text-align: center;
  padding: 1rem;
}

/* Popup Styles - UPDATED z-index to be above overlay */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
}

.popup-content {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  z-index: 1101;
}

.popup-body {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.popup-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
}

.popup-text {
  flex: 1;
}



.popup-title {
  color: #333;
  font-weight: bold;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  margin-top: 0;
  padding-right: 2rem;
}

.popup-description {
  color: #666;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 1200px) {
  .card {
    width: calc(48% - 1rem);
  }
}

@media (max-width: 768px) {
  .card {
    width: 100%;
  }
  
  .popup-content {
    width: 95%;
    padding: 1.5rem;
  }
  
  .popup-body {
    flex-direction: column;
    text-align: center;
  }
  
  .popup-img {
    width: 80px;
    height: 80px;
    align-self: center;
  }
  
  .popup-title {
    font-size: 1.3rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/discover-projects/discover-components/GridViewDiscover.vue